module.exports = __webpack_public_path__ + "img/arrow_next.1c5a08bb.png";